export default __webpack_public_path__ + "static/media/image2.f6f9db99.svg";